import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import { P } from '../AbstractElements'
import SvgIcon from '../Utils/CommonComponents/CommonSvgIcons'

export default function Footer() {
    return (
        <footer className="footer">
            <Container fluid>
                
            </Container>
        </footer>
    )
}
